<template>
  <div
    id="wineclub-list"
    class="wine-club-list"
  >
    <template v-if="clubs.length > 0 && clubs[0] != null">
      <div class="container">
        <header>
          <h1>Our Wineclubs</h1>
          <h2>Unbox. Uncork. Enjoy.</h2>
        </header>
        <section class="club-list">
          <ClubContainer
            v-for="club in clubs"
            :key="club.id"
            :club="club"
          />
        </section>
      </div>
    </template>
    <template v-else>
      <header>
        <h1>There are currently no clubs to display.</h1>
      </header>
    </template>
  </div>
</template>

<script>
import ClubContainer from "./components/ClubContainer";
import { pageMixin, asyncLoader } from "./mixins/wineclublist";

export default {
  name: "wineclub-list",
  asyncData: args => asyncLoader(args),
  mixins: [pageMixin],
  components: {
    ClubContainer
  }
};
</script>

<style scoped lang="scss">
header {
  text-align: center;
  padding-top: 2em;
}

.wine-club-list {
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  ::v-deep h1 {
    font-size: 1.6em;
    &.text-center {
      text-align: center;
    }
  }

  ::v-deep h2 {
    font-size: 1.4em;
  }

  ::v-deep h3 {
    font-size: 1.1em;
  }

  ::v-deep .btn {
    &.btn-small {
      padding: 0.3em 1em;
      font-size: 0.8em;
    }
    &.btn-large {
      padding: 1em 2em;
      font-size: 1em;
    }
  }
}
</style>
